'use strict'

import React from 'react';
import {ReportMessage} from '../log/HighlightReport.jsx';
import {BriefContent,ApprovableReport, BriefPidSlides} from '../brief/ProjectBrief.jsx';

import {ProjectPlan} from '../ProjectPlan.jsx';

import Layout from '../Layout.jsx';
import ProjectMenu from '../components/ProjectMenu.jsx';
import FormattedContent from '../components/FormattedContent.jsx';

import getProjectInitiationDocument from '../../app/model/getProjectInitiationDocument.js';

import Translations from '../../app/utils/translations.js';

let translations=new Translations([
    require('./labels/english.js'),
    require('./labels/norwegian.js')
  ])

class StakeholderCommunication extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).communication;
    let approach=this.props.pid.communicationManagementApproach;
    let fields=["name", "message", "requiredInformation", "providedInformation", "frequency"];
    return approach.stakeholderCommunication!==undefined && approach.stakeholderCommunication!==null && approach.stakeholderCommunication.length>0 ? (
      <div>
        <h3>{labels.stakeholderCommunication.title}</h3>
        <table cellSpacing="0" style={{fontSize:"inherit", border:"solid 1px lightgrey"}}>
          <thead>
            <tr style={{backgroundColor: "#e9e7e6"}}>
              {fields.map(field=>(
                <th key={field} style={{borderRight: field!=="frequency" ? "solid 1px lightgrey":undefined, padding: 5}}>{labels.stakeholderCommunication.columns[field].title}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {approach.stakeholderCommunication.map(stakeholder=>(
              <tr key={stakeholder.id}>
                {fields.map(field=>(
                  <td key={field} style={{borderTop: "solid 1px lightgrey", borderRight: field!=="frequency" ? "solid 1px lightgrey":undefined, padding: 5}}><FormattedContent value={stakeholder[field]}/></td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ) : null;
  }
}

class CommunicationManagementApproach extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).communication;
    let approach=this.props.pid.communicationManagementApproach;
    let fields=["process","tools","reporting", "timing", "roles"];
    return approach!==undefined && approach!==null &&
      ( fields.filter(field=>approach[field]!==undefined && approach[field]!==null && approach[field].trim().length>0).length>0
        || approach.stakeholderCommunication!==undefined && approach.stakeholderCommunication!== null && approach.stakeholderCommunication.length>0
      ) ? (
      <div>
        <h2>{labels.title}</h2>
        {fields.map(field=>approach[field]!==undefined && approach[field]!==null && approach[field].trim().length>0 ? (
          <div key={field}>
            <h3>{labels[field]}</h3>
            <FormattedContent value={approach[field]}/>
          </div>
        ) : null)}
        <StakeholderCommunication {...this.props}/>
      </div>
    ) : null;
  }
}

class RiskManagementApproach extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).risk;
    let approach=this.props.pid.riskManagementApproach;
    let fields=["process","tools","reporting", "timing", "roles", "tolerance", "budget"];
    return approach!==undefined && approach!==null && fields.filter(field=>approach[field]!==undefined && approach[field]!==null && approach[field].trim().length>0).length>0? (
      <div>
        <h2>{labels.title}</h2>
        {fields.map(field=>approach[field]!==undefined && approach[field]!==null && approach[field].trim().length>0 ? (
          <div key={field}>
            <h3>{labels[field]}</h3>
            <FormattedContent value={approach[field]}/>
          </div>
        ) : null)}
      </div>
    ) : null;
  }
}

class QualityManagementApproach extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).quality;
    let approach=this.props.pid.qualityManagementApproach;
    let fields=["process","tools","reporting", "timing", "roles"];
    return approach!==undefined && approach!==null && fields.filter(field=>approach[field]!==undefined && approach[field]!==null && approach[field].trim().length>0).length>0? (
      <div>
        <h2>{labels.title}</h2>
        {fields.map(field=>approach[field]!==undefined && approach[field]!==null && approach[field].trim().length>0 ? (
          <div key={field}>
            <h3>{labels[field]}</h3>
            <FormattedContent value={approach[field]}/>
          </div>
        ) : null)}
      </div>
    ) : null;
  }
}

class ChangeControlApproach extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).change;
    let approach=this.props.pid.changeControlApproach;
    let fields=["process","tools","reporting", "timing", "roles", "scales"];
    return approach!==undefined && approach!==null && fields.filter(field=>approach[field]!==undefined && approach[field]!==null && approach[field].trim().length>0).length>0? (
      <div>
        <h2>{labels.title}</h2>
        {fields.map(field=>approach[field]!==undefined && approach[field]!==null && approach[field].trim().length>0 ? (
          <div key={field}>
            <h3>{labels[field]}</h3>
            <FormattedContent value={approach[field]}/>
          </div>
        ) : null)}
      </div>
    ) : null;
  }
}

class ProjectControls extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).plan.projectControls;
    let approach=this.props.pid.projectControls;
    let fields=["projectControls"];
    return approach!==undefined && approach!==null && fields.filter(field=>approach[field]!==undefined && approach[field]!==null && approach[field].trim().length>0).length>0 ? (
      <div>
        <h2>{labels.title}</h2>
        {fields.map(field=>approach[field]!==undefined && approach[field]!==null && approach[field].trim().length>0 ? (
          <div key={field}>
            <FormattedContent value={approach[field]}/>
          </div>
        ) : null)}
      </div>
    ) : null;
  }
}

class ProjectPlanSection extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).plan.schedule;
    return this.props.pid.plan!==undefined && this.props.pid.plan!==null && this.props.pid.plan.length>0 ? (
      <div>
        <h2>{labels.title}</h2>
        <div style={{marginLeft: -20}}>
          <ProjectPlan {...this.props} planVersion="2" fontSize="70%" size={0.5} project={Object.assign({},this.props.project,{stages:this.props.pid.plan})} showInReport={true}/>
        </div>
      </div>
    ) : null;
  }
}

class InitiationDocumentContent extends React.Component {
  render() {
    let pid=this.props.pid;
    let labels=translations.getTranslation(this.props);
    let slides=[<QualityManagementApproach {...this.props} pid={pid}/>,
                <RiskManagementApproach {...this.props} pid={pid}/>,
                <ChangeControlApproach {...this.props} pid={pid}/>,
                <CommunicationManagementApproach {...this.props} pid={pid}/>,
                <ProjectPlanSection {...this.props} pid={pid}/>,
                <ProjectControls {...this.props} pid={pid}/> ];
    let slideTitles=[ labels.quality.title,
                      labels.risk.title,
                      labels.change.title,
                      labels.communication.title,
                      labels.plan.schedule.title,
                      labels.plan.projectControls.title ];
    return !this.props.presentationMode ? (
      <div>
        <BriefContent {...this.props} brief={pid}/>

        <QualityManagementApproach {...this.props} pid={pid}/>
        <RiskManagementApproach {...this.props} pid={pid}/>
        <ChangeControlApproach {...this.props} pid={pid}/>
        <CommunicationManagementApproach {...this.props} pid={pid}/>

        <ProjectPlanSection {...this.props} pid={pid}/>

        <ProjectControls {...this.props} pid={pid}/>
      </div>
    ) : (
      <BriefPidSlides {...this.props} doc={pid} pidSlides={slides} pidSlideTitles={slideTitles}/>
    );
  }

}

class InitiationDocumentDetails extends React.Component {
  render() {
    var date=new Date().toISOString().slice(0,10);
    let pid=this.props.pid;
    if (pid!==undefined && pid.date!==undefined) {
      date=new Date(Date.parse(pid.date)).toISOString().slice(0,10);
    }
    let nameAndDate=(this.props.project!==undefined ? this.props.project.name+" - " : "")+date;
    let type=this.props.pid!==undefined ? this.props.pid.type : undefined;
    let labels=translations.getTranslation(this.props);
    return false ? (
      <div>
        <div style={{display:"flex", padding:5, paddingLeft:10, fontFamily: "Verdana, sans-serif", justifyContent:"center"}}>
          <div style={{maxWidth:1016}}>
            <h1 style={{textAlign:"center"}}>
              <div style={{fontSize: "120%"}}>{labels.pid.title}</div>
              <div>{nameAndDate}</div>
            </h1>
            {type==="preview" ? (
              <ReportMessage message={labels.pid.messagePreview}/>
            ) : null }
            <InitiationDocumentContent {...this.props}/>
          </div>
        </div>
      </div>
    ) : (
      <ApprovableReport
        {...this.props}
        title={labels.pid.title}
        date={date}
        type={type}
        selected={this.props.pid}
        current={this.props.project.pid}
        report="PID"
        approveLabel={labels.approval.approve}
      >
        <InitiationDocumentContent {...this.props} title={labels.pid.title}/>
      </ApprovableReport>
    );
  }
}


function ignoreUndefinedAndInvariants(key,value) {
  if (value===undefined || value===null) {
    return undefined
  } else {
    switch (key) {
      case "date":
      case "type":
      case "history":
      case "version":
      case "majorVersion":
      case "minorVersion":
        return undefined;
      default:
        return value;
    }
  }
}

export class InitiationDocument extends React.Component {
  render() {
    var pid=getProjectInitiationDocument(this.props.project);
    let hasPreview=this.props.project.pid===undefined
      || this.props.project.pid!==undefined
        && JSON.stringify(pid,ignoreUndefinedAndInvariants)
          !==JSON.stringify(this.props.project.pid,ignoreUndefinedAndInvariants);
    if (hasPreview) {
      pid=Object.assign({},pid,{type:"preview"});
    } else if (this.props.project.pid!==undefined) {
      pid=this.props.project.pid;
    }
    if (this.props.selected!==undefined) {
      if (this.props.selected.indexOf("-DRAFT")>0 && this.props.project.pid.type==="draft" && this.props.project.pid.version===parseInt(this.props.selected)) {
        pid=this.props.project.pid;
      } else if (this.props.project.pid!==undefined && this.props.project.pid.history!==undefined){
        let foundPID=this.props.project.pid.history.filter(item=>item.version===parseInt(this.props.selected))[0];
        if (foundPID!==undefined) {
          pid=foundPID;
        }
      }
    }
    return (
      <InitiationDocumentDetails {...this.props} pid={pid} hasPreview={hasPreview}/>
    )
  }
}

export default class InitiationDocumentPage extends React.Component {
  render() {
    var menu=(this.props.showMenu===true) ? <ProjectMenu {...this.props}/> : undefined;
    return this.props.fullPage ? (
      <html>
        <head>
          <meta http-equiv="Content-Type" content="text/html; charset=UTF-8"></meta>
        </head>
        <body>
          <InitiationDocument {...this.props}/>
        </body>
      </html>
    ) : (
      <Layout {...this.props} projectMenu={menu}>
        <InitiationDocument {...this.props}/>
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./views/pid/InitiationDocument.jsx